import React from "react";

import { ErrorContainer, Title } from "./Error.styled";

const Error = () => {
  return (
    <ErrorContainer>
      <Title>404</Title>
      <h4>Oops, not found.</h4>
      <a href="/">Back Home</a>
    </ErrorContainer>
  );
};

export default Error;
